import { initAccordion } from "./accordion";
import { initAccount } from "./accountdetail";
import { initAccountNavigation} from "./accountnavigation";
import { initBentoBoxModal } from "./bentobox";
import { initBlogDetailsShare } from "./blogdetails";
import { initBlogFilters } from "./blogfilters";
import { initBlogPosts } from "./blogpost";
import { initCollectionOverview } from "./collectionsoverview";
import { initCollectionsItems } from "./collectionsitems";
import { initCustomVideoPlayers } from "./video";
import { initEditorblog } from "./editorblog";
import { initEmailSignup } from "./emailsignup";
import { initFindARep } from "./findarep";
import { initFlyoutManager } from "./flyoutManager";
import { initFooter } from "./footer";
import { initForgotPassword } from "./forgotPassword";
import { initFormManager } from "./formManager";
import { initHeaderNav } from "./header";
import { initHero } from "./hero";
import { initHorizontalScrollCards } from "./horizontalscrollcards";
import { initImageComparisonSliders } from "./imagecomparison";
import { initImageGallery } from "./imagegallery";
import { initImageGalleryCarousel } from './imagegallerycarousel';
import { initProjectBoardList } from "./projectboard";
import { initProjectBoardDetails } from "./projectboarddetailsroot";
import { initRegister } from "./register";
import { initSearchPage } from "./searchpage";
import { initProductListing } from  "./productlisting"
import { initSegmentSelectors } from "./segmentselector";
import { initShipping } from "./shippingdetail";
import { initSignin } from "./signin";
import { initTestimonialCarousel } from "./testimonial";
import { initAddToBoard } from "./addtoboard";
import { initProductListingBlock } from "./productlistingblock";
import { initCompareDrawer } from "./comparedrawer";
import { initCompareModal } from "./comparemodal";
import { initUpcomingEvents } from "./upcomingevents";
import { initVisualizer } from "./visualizer";
import { initOrderHistory } from "./orderhistory";
import Htmx from 'htmx.org';
import "./analytics";
import CartManager from "./cartManager";

window.mannington = window.mannington || {};
window.htmx = Htmx;

// Update cart count badges when cart is updated via HTMX
document.body.addEventListener('htmx:afterSwap', (event) => {
    if (event.detail.target.classList.contains('tmp-account-cart')) {
        CartManager.refreshCartCount();
    }
});

// expose function to lazy load product details
window.mannington.initializeProductDetails = async (args) => {
    const module = await import('./productDetails.js');
    return module.initializeProductDetails(args);
};

initAccordion();
initAccount();
initAccountNavigation();
initBentoBoxModal();
initBlogDetailsShare();
initBlogFilters(initBlogPosts);
initBlogPosts();
initCollectionOverview();
initCollectionsItems();
initCustomVideoPlayers();
initEditorblog();
initEmailSignup();
initFindARep();
initFlyoutManager();
initFooter();
initForgotPassword();
initFormManager();
initHeaderNav();
initHero();
initHorizontalScrollCards();
initImageComparisonSliders();
initImageGallery();
initImageGalleryCarousel();
initProjectBoardList();
initProjectBoardDetails();
initSearchPage();
initProductListing();
initRegister();
initSegmentSelectors();
initShipping();
initSignin();
initTestimonialCarousel();
initAddToBoard();
initProductListingBlock();
initCompareDrawer();
initCompareModal();
initUpcomingEvents();
initVisualizer();
initOrderHistory();